// Pikaday provides a custom date picker
function registerPikaday(onSelect) {
    return new Pikaday({
        field: document.getElementById('availability-date'),
        firstDay: 1,
        minDate: new Date('2000-01-01'),
        maxDate: new Date('2050-12-31'),
        format: 'MM-DD-YYYY',
        yearRange: [2010, 2050],
        onSelect: onSelect
    });
}

function paginate(currentPageInput, pageSizeElement, submitFormFunction) {

    $('#first-page-button').click(function () {
        currentPageInput.value = 1;
        submitFormFunction();
    });

    $('#previous-page-button').click(function () {
        currentPageInput.value = currentPageInput.value - 1;
        submitFormFunction();
    });

    $('.page-button').click(function (e) {
        currentPageInput.value = e.target.dataset.pageNumber;
        submitFormFunction();
    });

    $('#next-page-button').click(function () {
        currentPageInput.value = parseInt(currentPageInput.value) + 1;
        submitFormFunction();
    });

    $('#last-page-button').click(function (e) {
        currentPageInput.value = e.target.dataset.lastPage;
        submitFormFunction();
    });

    pageSizeElement.change(function () {
        currentPageInput.value = 1;
        submitFormFunction();
    });
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

$(function () {
    // prevent bootstrap dropdown from closing when clicking dropdown headers
    $('.dropdown-link-disabled').on('click', function (e) {
        e.stopPropagation();
    });

    $('.company-cards-toggle').on('click', function () {
        $('.company-cards').toggle();
    });

    // Marketing Messages are banners that are managed through the admin UI, and are displayed
    // at the top of the page. If a user closes the message, they're opted out of seeing
    // that specific message by adding an OptOut record to the database.
    $('#marketing-message').on('click', function () {
        var marketingMessageContainer = $('#marketing-message');

        var marketingMessageId = marketingMessageContainer.data('marketingMessageId');
        var userId = marketingMessageContainer.data('userId');

        marketingMessageContainer.remove();

        if (userId) {
            $.ajax('/MarketingMessageOptOut', {
                type: 'POST',
                data: {
                    marketingMessageId: marketingMessageId,
                    userId: userId
                }
            });
        }
    });
});

$(function () {
    $('.subnav').on('click', function(e) {
        $(this).toggleClass('active');

        $(document).one('click', function closeMenu (e){
            if($('.subnav').has(e.target).length === 0){
                $('.subnav').removeClass('active');
            } else {
                $(document).one('click', closeMenu);
            }
        });
    });

    $('#navbar-search-icon').click(function() {
        $('#filter-input-mobile').focus();
        $('#filter-input-mobile').select();
    })

    $('#toggle-hamburger').on('click', function () {
        $(this).find('i').toggleClass('glyphicon-menu-hamburger glyphicon-remove');
    });

    $('.toggle-chev').on('click', function () {
        $(this).find('i').toggleClass('glyphicon-chevron-down glyphicon-chevron-up');
        $(this).find('.glyphicon-search').toggle();
    });
});

// sticky header
$(function () {
    var startStickyAt = 160;
    var prevScrollDepth = 0;
    var prevState = 'default';
    var $header = $('#desktop-header');

    $(window).on('scroll', function (e) {
        var scrollDepth = (window.pageYOffset);
        if (scrollDepth < startStickyAt) {
            $header.removeClass('fixed scrolling-down scrolling-up');
            prevScrollDepth = scrollDepth;
            prevState = 'default';
            return;
        }

        $header.addClass('fixed');
        if (prevScrollDepth > scrollDepth) {
            $header.removeClass('scrolling-down');
            $header.addClass('scrolling-up');
            prevScrollDepth = scrollDepth;
            prevState = 'scrolling-up';
            return;
        }
        
        prevState === 'default' ? $header.addClass('no-transition') : $header.removeClass('no-transition');
        $header.removeClass('scrolling-up');
        $header.addClass('scrolling-down');
        prevState = 'scrolling-down';
        prevScrollDepth = scrollDepth;
    });
});

